var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BoxOne",on:{"click":_vm.maskchange}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.boxData.title))]),_c('img',{attrs:{"src":require("@/assets/njImgs/njMidwk.png"),"alt":""}}),_c('div',{staticClass:"contentBox"},[_c('div',[_vm._v(_vm._s(_vm.boxData.data))]),_c('div',[_vm._v(" "+_vm._s(_vm.boxData.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }